<template>
  <a-form :model="formModel" layout="vertical" :disabled="loading">
    <a-flex gap="small" vertical>
      <a-typography-text>Отступы</a-typography-text>

      <a-flex align="center" gap="small" class="margins">
        <a-form-item label="Верх" name="top">
          <a-input-number
            :step="1"
            v-model:value="labelTemplateFormState.topMarginField"
          ></a-input-number>
        </a-form-item>
        x
        <a-form-item label="Лево" name="left">
          <a-input-number
            :step="1"
            v-model:value="labelTemplateFormState.leftMarginField"
          ></a-input-number>
        </a-form-item>
        x
        <a-form-item label="Низ" name="bottom">
          <a-input-number
            :step="1"
            v-model:value="labelTemplateFormState.bottomMarginField"
          ></a-input-number>
        </a-form-item>
        x
        <a-form-item label="Право" name="right">
          <a-input-number
            :step="1"
            v-model:value="labelTemplateFormState.rightMarginField"
          ></a-input-number>
        </a-form-item>
      </a-flex>
    </a-flex>
  </a-form>
</template>

<script setup lang="ts">
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { storeToRefs } from "pinia";
import { computed } from "vue";

defineProps<{ loading: boolean }>();

const labelTemplateFormState = useLabelTemplateFormStore();

const { bottomMarginField, leftMarginField, rightMarginField, topMarginField } =
  storeToRefs(labelTemplateFormState);

const formModel = computed(() => ({
  top: topMarginField.value,
  bottom: bottomMarginField.value,
  left: leftMarginField.value,
  right: rightMarginField.value,
}));
</script>

<style scoped lang="scss">
.margins {
  align-items: center;
  gap: 3px;

  :deep(.ant-input-number) {
    width: 78px;
    flex: unset;
  }

  .ant-form-item {
    flex: unset;
    width: 78px;
    margin-bottom: 26px !important;
  }
}
</style>
